import React from 'react';
import Dashboard from '../../containers/Dashboard/Dashboard';

export class DashboardPage extends React.Component {
  render() {
    return (
        <Dashboard />
    );
  }
}